import { AnimatePresence, motion } from 'framer-motion';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Checkbox } from '~/commonComponents';

interface ICandidateListItemProps {
  id: string;
  name: string;
  isSelected: boolean;
  disabled?: boolean;
  onToggle: (id: string) => void;
}

export const CandidateListItem = ({
  id,
  name,
  isSelected,
  disabled = false,
  onToggle,
}: ICandidateListItemProps) => (
  <AnimatePresence>
    <motion.div
      role="presentation"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      layout
      onClick={() => !disabled && onToggle(id)}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 0px',
        borderBottom: `1px solid ${colors.neutral[100]}`,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <Row align="center" gap={3} width="100%">
        <Typography as="span" bold size="body_large" style={{ flex: 1 }}>
          {name}
        </Typography>
        <Checkbox checked={isSelected} style={{ opacity: disabled ? 0.5 : 1 }} />
      </Row>
    </motion.div>
  </AnimatePresence>
);
